<template>
  <div class="p-3">
    <div
      class="justify-end items-center my-3"
      :class="[$vuetify.breakpoint.lgAndUp ? 'flex justify-end' : 'flex-col']"
      v-if="!showAddStore"
    >
      <div
        class="justify-end mr-4"
        :class="[$vuetify.breakpoint.lgAndUp ? 'flex' : 'flex-col']"
      >
        <v-col
          :cols="$vuetify.breakpoint.lgAndUp ? '' : '12'"
          :class="[$vuetify.breakpoint.lgAndUp ? '' : 'ml-auto']"
        >
          <v-text-field
            v-model="filterStore"
            label="Store Name"
            solo
            flat
            clearable
            prepend-inner-icon="mdi-magnify"
            @input="handleInput"
            outlined
            dense
            hide-details
          ></v-text-field>
        </v-col>
      </div>
      <v-tooltip top>
        <template #activator="{ on, attrs }">
          <v-btn
            @click="toggleshowAddStore()"
            :color="$vuetify.theme.currentTheme.primary"
            :class="[
              $vuetify.breakpoint.lgAndUp
                ? ' white--text'
                : 'ml-3 flex-col white--text mt-2',
            ]"
            v-bind="attrs"
            v-on="on"
            v-show="canWrite"
          >
            Add Store
            <v-icon right dark>mdi-plus</v-icon>
          </v-btn>
        </template>
        <span>Add Store</span>
      </v-tooltip>
    </div>
    <div v-if="showTable" class="overflow-x-auto overflow-y-auto">
      <v-data-table
        :headers="headers"
        :items="stores"
        class="pl-7 pr-7 pt-4"
        :options.sync="options"
        :footer-props="{ itemsPerPageOptions: [5, 10, 15, 30] }"
        :server-items-length="totalItems"
        fixed-header
        :loading="loadTable"
      >
        <template v-slot:item.storeName="{ item }">
          <td class="px-4 py-6 font-semibold">{{ item.storeName }}</td>
        </template>
        <template v-slot:item.storeDescription="{ item }">
          <td class="px-4 font-semibold">{{ item.storeDescription }}</td>
        </template>
        <template v-slot:item.storeLocation="{ item }">
          <td class="px-4 font-semibold">
            {{
              item.storeLocation
                ? Object.values(item.storeLocation).join(", ")
                : ""
            }}
          </td>
        </template>
        <template v-slot:item.storeStatus="{ item }">
          <td
            :class="getStoreStatusClr(item.storeStatus)"
            class="px-4 font-semibold"
          >
            {{ item.storeStatus }}
          </td>
        </template>
        <template v-slot:item.action="{ item }">
          <td class="px-4">
            <action-button
              :item="item"
              :canEdit="canEdit"
              :showEditButton="canEdit"
              :handleEdit="() => storeEdit(item)"
              :showDeleteButton="false"
            />
          </td>
        </template>
      </v-data-table>
    </div>
    <div v-else-if="showAddStore">
      <AddStorePartner
        @cancel="toggleShowTable"
        :entityType="'Store'"
        :editStoreData="selectedStoreData"
      />
    </div>
  </div>
</template>

<script>
import AddStorePartner from "~/components/Workforce/InventorySettings/AddStorePartner.vue";
import ActionButton from "../../ActionButton.vue";
import { debounce, hasPermission } from "@/utils/common";
import permissionData from "@/utils/permissions";
export default {
  name: "InventoryIn",
  components: {
    AddStorePartner,
    ActionButton,
  },
  data() {
    return {
      userData: this.$store.state.wfmPermissions,
      stores: [],
      filterStore: "",
      options: { itemsPerPage: 5, page: 1 },
      totalItems: 0,
      showTable: true,
      loadTable: true,
      showAddStore: false,
      selectedStoreData: null,
    };
  },
  watch: {
    options: {
      handler() {
        this.fetchStores();
      },
      deep: true,
    },
  },
  computed: {
    headers() {
      const headers = [
        { text: "Store Name", value: "storeName", sortable: false },
        { text: "Descrption", value: "storeDescription", sortable: false },
        { text: "Location", value: "storeLocation", sortable: false },
        { text: "Store Status", value: "storeStatus", sortable: false },
        this.canEdit
          ? { text: "Action", value: "action", sortable: false }
          : [],
      ];
      return headers;
    },
    canEdit() {
      return hasPermission(this.userData, permissionData.inventoryEdit);
    },
    canWrite() {
      return hasPermission(this.userData, permissionData.inventoryWrite);
    },
  },
  methods: {
    getStoreStatusClr(status) {
      const statuses = {
        OPERATIONAL: "text-green-500",
        NON_OPERATIONAL: "text-red-500",
      };

      return statuses[status];
    },
    toggleShowTable() {
      this.showAddStore = false;
      this.showTable = true;
      this.selectedStoreData = null;
      this.fetchStores();
    },
    toggleshowAddStore() {
      this.showTable = false;
      this.showAddStore = true;
    },
    async fetchStores() {
      try {
        const { page, itemsPerPage } = this.options;
        const params = { page, limit: itemsPerPage };
        if (this.filterStore) {
          params.search = this.filterStore;
        }
        this.loadTable = true;
        const response = await this.$axios.get("/workforce/ecom/stores", {
          params,
        });
        this.loadTable = false;
        this.stores = response.data.stores;
        this.totalItems = response.data.pagination?.totalCount;
      } catch (error) {
        console.error("An error occurred:", error);
      }
    },
    storeEdit(item) {
      this.selectedStoreData = item;
      this.toggleshowAddStore();
    },
    handleInput: debounce(function () {
      this.fetchStores();
      this.options.page = 1;
    }, 1000),
  },
};
</script>

<style scoped></style>
